import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, solutions } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Solutions = () => {

          const { t } = useTranslation();

             useEffect(() => {
                        AOS.init({ duration: 2000, once: false }); 
                      }, []);

  return (
     <div data-aos="fade-up" className='mt-[88px] md:mt-[104px] '>
            <div className='max-w-containerSm md:max-w-container mx-auto md:flex justify-between gap-10'>
            <div className='md:w-[45%]'>
            <img className='w-full' src={solutions}></img>
            </div>
            <div className='md:w-[55%] mt-10 md:mt-0'>
            <p className='text-[24px] md:text-[32px] font-medium text-[#008A7F]'>{t("Peşəkar Həllər, Rahat Mühit!")}</p>
            <p className='text-[14px] md:text-[16px] text-[#7A7A7A] mt-4'>{t("Mütəxəssis komandamız hər bir layihəyə individual yanaşaraq, müasir texnologiyalar və innovativ həllərlə optimal nəticələr təqdim edir. İstər yaşayış binaları, istərsə də kommersiya obyektləri üçün enerji səmərəli və uzunömürlü sistemlər quraşdırırıq. Bizim məqsədimiz yalnız avadanlıq quraşdırmaq deyil, eyni zamanda, rahat və təhlükəsiz mühit yaratmaqdır. Bunun üçün ən son standartlara uyğun layihələndirmə, montaj və texniki xidmət göstəririk. Müştəri məmnuniyyəti bizim üçün əsas prioritetdir. Hər bir mərhələdə sizə peşəkar məsləhətlər verərək, ən uyğun həlli təklif edirik. Bizimlə əməkdaşlıq edərək, yüksək keyfiyyət və etibarlılığa zəmanət verən xidmətlərdən yararlana bilərsiniz.")}</p>
           <div className='flex justify-center md:justify-end'>
           <a className='group' href="/about">
                       <div className='flex items-center mt-6 justify-between w-[100px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px] '>
                       <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                          <img
                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                      src={rightArrow}
                                      alt="" 
                                    />
                                    <img
                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                      src={rightArrowHover}
                                      alt=""
                                    />
                       </div>
                     </a>
           </div>
            </div>
        </div>
        </div>
  )
}

export default Solutions